"use strict";
(() => {
  var __async = (__this, __arguments, generator) => {
    return new Promise((resolve, reject) => {
      var fulfilled = (value) => {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      };
      var rejected = (value) => {
        try {
          step(generator.throw(value));
        } catch (e) {
          reject(e);
        }
      };
      var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
      step((generator = generator.apply(__this, __arguments)).next());
    });
  };

  // src/scripts/components/tagalys-init.js
  var isTagalysConfigValid = ({ sdkUrl, serverUrl, clientCode, apiKey, storeId }) => sdkUrl && serverUrl && clientCode && apiKey && storeId;
  var isTagalysEnabled = ({ enable = false }) => enable;
  var setTagalysConfiguration = ({ enable, serverUrl, clientCode, apiKey, storeId }) => {
    var _a, _b, _c, _d;
    if (!enable || !serverUrl || !clientCode || !apiKey || !storeId) return;
    const language = (_a = window.theme.locale.isoCode) != null ? _a : "en";
    const country = (_b = window.theme.localization.country) != null ? _b : "NZ";
    window.Tagalys.setConfiguration({
      api: {
        serverUrl,
        credentials: {
          clientCode,
          apiKey
        },
        storeId
      },
      locale: `${language}-${country}`,
      currency: {
        displayFormatter: "{{currencyLabel}}{{value}}",
        code: (_c = window.theme.localization.currency) != null ? _c : "NZD",
        label: (_d = window.theme.localization.currencySymbol) != null ? _d : "$",
        fractionalDigits: 2,
        forceFractionalDigits: true
      },
      analyticsStorageConsentProvided() {
        return true;
      },
      track: true
    });
  };
  var setPlatformConfigurationForTagalys = ({ enable, storefrontApiAccessToken }) => {
    var _a, _b;
    if (!enable) return;
    const productMetafields = [
      {
        namespace: "card",
        key: "badge"
      },
      {
        namespace: "card",
        key: "message"
      }
    ];
    window.Tagalys.setPlatformConfiguration({
      platform: "Shopify",
      countryCode: (_a = window.theme.localization.country) != null ? _a : "NZ",
      baseCountryCode: (_b = window.theme.localization.baseCountry) != null ? _b : "NZ",
      useStorefrontAPIForSecondaryMarkets: Boolean(storefrontApiAccessToken),
      waitForStorefrontAPI: Boolean(storefrontApiAccessToken),
      storefrontAPI: {
        accessToken: storefrontApiAccessToken,
        myShopifyDomain: window.Shopify.shop
      },
      metafields: {
        products: productMetafields
      }
    });
  };
  var onTagalysReady = (callback) => {
    const checkTagalys = setInterval(() => {
      if (!window.Tagalys || !window.tagalysReady) {
        window.console.error("TWP | onTagalysReady | Tagalys is not ready");
        return;
      }
      clearInterval(checkTagalys);
      if (typeof callback === "function") {
        callback();
      }
    }, 150);
  };
  var initTagalys = () => {
    const tagalysConfig = window.theme.tagalys;
    if (!tagalysConfig || !isTagalysConfigValid(tagalysConfig) || !isTagalysEnabled(tagalysConfig)) {
      return;
    }
    const checkTagalys = setInterval(() => {
      if (!window.Tagalys) {
        window.console.error("TWP | tagalysInit | Tagalys has not loaded");
        return;
      }
      clearInterval(checkTagalys);
      setTagalysConfiguration(window.theme.tagalys);
      setPlatformConfigurationForTagalys(window.theme.tagalys);
      window.tagalysReady = true;
      document.dispatchEvent(new Event("tagalys:ready"));
    }, 150);
  };

  // src/scripts/utils/tagalys.js
  var constructLocalisedProductLink = (product) => {
    const marketRoot = window.theme.locale.rootUrl === "/" ? "" : window.theme.locale.rootUrl;
    return `${window.location.origin}${marketRoot}/products/${product.handle}`;
  };
  var decodeHtmlEntities = (text) => {
    if (!text) return "";
    const textArea = document.createElement("textarea");
    textArea.innerHTML = text;
    return textArea.value;
  };

  // src/scripts/utils/shopify-images.js
  var imageUrl = (url, width, height, crop) => {
    if (!url || !(width || height)) return null;
    if (width && typeof width !== "number") return null;
    if (height && typeof height !== "number") return null;
    if (crop && typeof crop !== "string") return null;
    try {
      const urlObj = new URL(url, window.location.origin);
      const params = urlObj.searchParams;
      const currentWidth = params.get("width");
      const currentHeight = params.get("height");
      const currentCrop = params.get("crop");
      if (!height && currentHeight) params.delete("height");
      if (!width && currentWidth) params.delete("width");
      if (!crop && currentCrop) params.delete("crop");
      if (width) params.set("width", width);
      if (height) params.set("height", height);
      if (crop) params.set("crop", crop);
      return urlObj.href;
    } catch (error) {
      return null;
    }
  };

  // src/scripts/components/responsive-image.js
  var responsiveImage = (image, imageAlt, maxWidth, lazyload = true, sizes = "", aspectRatio = "natural") => {
    const widths = [160, 320, 480, 640, 800, 960, 1120, 1280, 1440, 1600, 1920, 2240, 2560];
    let srcset = "";
    widths.forEach((width, index) => {
      if (width > maxWidth) return;
      const src = imageUrl(image.src, width);
      if (index > 0) {
        srcset += ", ";
      }
      srcset += `${src} ${width}w`;
    });
    return `
    <img
      class="component-image__image"
      src="${imageUrl(image.src, 480)}"
      srcset="${srcset}"
      loading="${lazyload ? "lazy" : "eager"}"
      sizes="${sizes}"
      width="${image.width}"
      height="${image.height}"
      alt="${imageAlt}"
    />`;
  };
  var responsive_image_default = responsiveImage;

  // src/scripts/components/product-card-template/product-card-media.js
  var renderProductCardMedia = (product, productLink) => {
    var _a, _b, _c;
    const imgAspectRatio = "2-3";
    const imgMaxWidth = "1120";
    const imgSizes = "(min-width: 61.875rem) 26.5vw, (min-width: 48rem) 35vw, 90vw";
    const imgDefaultAlt = product.title;
    const showSecondaryImages = (_b = (_a = window.theme) == null ? void 0 : _a.productCard) == null ? void 0 : _b.showSecondaryImages;
    const productImages = product.images;
    const featuredImage = productImages[0];
    const featuredImageAlt = (_c = featuredImage == null ? void 0 : featuredImage.alt) != null ? _c : imgDefaultAlt;
    const featuredImageMarkup = productImages.length > 1 ? `${responsive_image_default(featuredImage, featuredImageAlt, imgMaxWidth, true, imgSizes, imgAspectRatio)}
    ${responsive_image_default(productImages[1], featuredImageAlt, imgMaxWidth, true, imgSizes, imgAspectRatio)}` : `
    ${responsive_image_default(featuredImage, featuredImageAlt, imgMaxWidth, true, imgSizes, imgAspectRatio)}`;
    let sliderMarkup = "";
    if (showSecondaryImages && product.images.length > 1) {
      let otherImagesMarkup = "";
      product.images.forEach((image, index) => {
        var _a2;
        if (index === 0) return;
        const imageAlt = (_a2 = image.alt) != null ? _a2 : imgDefaultAlt;
        otherImagesMarkup += `<div class="product-card__slide"><a href=${productLink}>${responsive_image_default(
          image,
          imageAlt,
          imgMaxWidth,
          true,
          imgSizes,
          imgAspectRatio
        )}</a></div>`;
      });
      sliderMarkup = `<div class="product-card__slider" data-slider>
      <div class="product-card__slide">${featuredImageMarkup}</div>
      ${otherImagesMarkup}
    </div>`;
    }
    if (sliderMarkup) {
      return sliderMarkup;
    }
    return featuredImageMarkup;
  };
  var product_card_media_default = renderProductCardMedia;

  // src/scripts/components/product-card-template/product-card-render.js
  var renderCardBadge = (tags) => {
    var _a;
    if (!(tags == null ? void 0 : tags.length)) return "";
    const badgeTags = tags.filter((tag) => tag.includes("label:"));
    if (badgeTags.length === 0) return "";
    return `
    <div class="card__badge ${(_a = window.theme) == null ? void 0 : _a.badgePosition}">
      ${badgeTags.map((tag) => {
      const badgeText = tag.replace("label:", "");
      return `<span class="badge">${badgeText}</span>`;
    }).join("")}
    </div>
  `;
  };
  var renderWishlistButton = (product) => {
    var _a, _b;
    if (!((_b = (_a = window.theme) == null ? void 0 : _a.wishlist) == null ? void 0 : _b.twpEnable)) return "";
    const wishlistProduct = product;
    wishlistProduct.featured_image = product.images[0].src;
    return `
    <div class="osc-css wrapper-button-collection">
      <div
        class="button-collection-wishlist button-${product.id}"
        data-product-id="${product.id}"
        data-has-only-variant="${product.has_only_default_variant}"
        data-product-title="${product.title}"
      >
        <span class="button-icon"></span>
        <span class="button-text"></span>
      </div>
    </div>
    <script type="application/json" id="ProductJson-${product.id}">
      ${JSON.stringify(product)}
    <\/script>
    <script type="application/json" id="OptionJson-${product.id}">
      ${JSON.stringify(product.options_with_values)}
    <\/script>
  `;
  };
  var renderCardMessage = (metafields) => {
    var _a, _b;
    if (!((_b = (_a = metafields == null ? void 0 : metafields.card) == null ? void 0 : _a.message) == null ? void 0 : _b.value)) return "";
    return `<div class="card__message caption">${metafields.card.message.value}</div>`;
  };
  var renderVendor = (vendor) => {
    if (!vendor) return "";
    return `
    <span class="visually-hidden">Vendor</span>
    <div class="caption-with-letter-spacing">${vendor}</div>
  `;
  };
  var renderPrice = (product, helpers, productPrice, productCompareAtPrice) => {
    var _a, _b, _c, _d, _e, _f;
    const isOnSale = helpers.isProductOnSale(productCompareAtPrice, productPrice);
    if (product.price_varies) {
      return `
      <span>
        ${(((_c = (_b = (_a = window.theme) == null ? void 0 : _a.strings) == null ? void 0 : _b.product) == null ? void 0 : _c.priceFrom) || "From {{ price }}").replace(
        "{{ price }}",
        helpers.formatCurrency(product.price_min || productPrice)
      )}
      </span>
    `;
    }
    const compareAtPriceHtml = isOnSale ? `
    <span class="visually-hidden">${((_f = (_e = (_d = window.theme) == null ? void 0 : _d.strings) == null ? void 0 : _e.product) == null ? void 0 : _f.regularPrice) || "Regular price"}</span>
    <s data-compare-price>${helpers.formatCurrency(productCompareAtPrice)}</s>
  ` : "";
    return `
    ${compareAtPriceHtml}
    <span data-product-price ${isOnSale ? 'class="product-card__sale-price"' : ""}>
      ${helpers.formatCurrency(productPrice)}
    </span>
  `;
  };
  var renderProductCard = (product, helpers) => {
    const templateOptions = helpers.getTemplateOptions("product");
    const productLink = templateOptions.productPageUrl(product);
    const productPrice = helpers.getPrice ? helpers.getPrice(product) : product.price;
    const productCompareAtPrice = helpers.getCompareAtPrice ? helpers.getCompareAtPrice(product) : product.compare_at_price;
    const isOnSale = helpers.isProductOnSale(product.compare_at_price, product.price);
    return `
    <div class="card-wrapper product-card-wrapper underline-links-hover product-card-wrapper-TWP">
      ${renderWishlistButton(product)}
      <div class="card card--standard card--media" style="--ratio-percent: 128.47826086956522%">
        <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 128.47826086956522%">
          <a href=${productLink} class="card__content full-unstyled-link">
            <div class="card__media">
              <div class="media media--transparent ${product.images.length > 1 ? "media--hover-effect" : ""}">
                ${product_card_media_default(product, productLink)}
                <span class="visually-hidden">${product.title}</span>
              </div>
            </div>
            ${renderCardBadge(product.tags)}
          </a>
        </div>
        <div class="card__content">
          <div class="card__information">
            ${renderVendor(product.vendor)}
            <h3 class="card__heading">
              <a class="full-unstyled-link" href=${productLink}>${product.title}</a>
            </h3>
            <div class="card-information">
              <span class="caption-large light"></span>
              <div class="price ${isOnSale ? "price--on-sale" : ""}">
                <div class="price__container">
                  ${renderPrice(product, helpers, productPrice, productCompareAtPrice)}
                </div>
              </div>
              ${renderCardMessage(product.metafields)}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
  };
  var product_card_render_default = renderProductCard;

  // src/scripts/components/tagalys-widget-templates.js
  var tagalysWidgetTemplates = (limit, widgetElem) => {
    var _a, _b, _c, _d, _e, _f;
    const sectionId = (_a = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _a.sectionId;
    const sectionTitle = (_b = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _b.title;
    const headingSize = (_d = (_c = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _c.headingSize) != null ? _d : "h5";
    const buttonLabel = (_e = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _e.buttonLabel;
    const buttonUrl = (_f = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _f.buttonUrl;
    return {
      widget: {
        options: {
          limit,
          displayFormat: "grid",
          includeTagalysCSS: false
        },
        render: (html, args) => {
          const props = args.props;
          const helpers = props.helpers;
          const products = helpers.getProducts();
          if (props.loading === false) {
            if (products.length === 0) {
              return null;
            }
            return html`
            <${args.templates.title} />
            <${args.templates.productList} />
            <${args.templates.button} />
          `;
          }
        }
      },
      title: {
        render: (html) => {
          if (sectionTitle) {
            return html`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${headingSize}">${sectionTitle}</h2>
            </div>
          `;
          }
          return html``;
        }
      },
      productList: {
        render: (html, args) => html`
        <slider-component class="slider-component-full-width">
          <${args.templates.products} />
          <${args.templates.carouselActions} />
        </slider-component>
      `
      },
      products: {
        render: (html, args) => {
          const props = args.props;
          const products = props.helpers.getProducts();
          return html`<ul
          id="Slider-${sectionId}"
          class="grid product-grid contains-card contains-card--product contains-card--standard grid--4-col-desktop grid--2-col-tablet-down slider slider--desktop slider--tablet grid--peek"
        >
          ${products.map(
            (product, index) => html`<li class="grid__item slider__slide scroll-trigger animate--slide-in">
                <${args.templates.product} key=${index} product=${product} />
              </li>`
          )}
        </ul> `;
        }
      },
      product: {
        options: {
          // Generate the product page URL using the product object
          productPageUrl(product) {
            return constructLocalisedProductLink(product);
          }
        },
        render: (html, args) => {
          const props = args.props;
          const product = props.product;
          const helpers = props.helpers;
          return html`<div
          class="tagalys-section__slide"
          id="Slide-${product.id}"
          dangerouslySetInnerHTML=${{
            __html: product_card_render_default(product, helpers)
          }}
        />`;
        }
      },
      carouselActions: {
        render: (html) => {
          var _a2, _b2, _c2, _d2, _e2, _f2;
          return html`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.accessibility) == null ? void 0 : _c2.previousSlide}"
            aria-controls="Slider-${sectionId}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(_f2 = (_e2 = (_d2 = window.theme) == null ? void 0 : _d2.strings) == null ? void 0 : _e2.accessibility) == null ? void 0 : _f2.nextSlide}"
            aria-controls="Slider-${sectionId}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `;
        }
      },
      button: {
        render: (html) => {
          if (buttonLabel && buttonUrl) {
            return html`
            <div class="product-recommendations__button">
              <a href="${buttonUrl}" class="button button--secondary">${buttonLabel}</a>
            </div>
          `;
          }
          return html``;
        }
      }
    };
  };
  var tagalys_widget_templates_default = tagalysWidgetTemplates;

  // src/scripts/components/tagalys-recommendations.js
  var selectors = {
    widget: '[data-tagalys-widget="recommendations"]'
  };
  var tagalysRecommendations = (widgetElem) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const recommendationId = (_a = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _a.recommendationId;
    const productId = (_b = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _b.productId;
    const widgetLimit = (_d = (_c = widgetElem == null ? void 0 : widgetElem.dataset) == null ? void 0 : _c.limit) != null ? _d : 8;
    if (!recommendationId || !productId) {
      window.console.error("TWP | tagalysSimilarProducts | recommendationId or productId is missing");
      return;
    }
    (_g = (_f = (_e = window.Tagalys) == null ? void 0 : _e.UIWidgets) == null ? void 0 : _f.Recommendations) == null ? void 0 : _g.init(selectors.widget, {
      recommendationId,
      productId,
      templates: tagalys_widget_templates_default(widgetLimit, widgetElem),
      callbacks: {
        afterInitialRender: () => {
          const sliderComponent = widgetElem.querySelector("slider-component");
          sliderComponent == null ? void 0 : sliderComponent.reinitialiseSlider();
        }
      }
    });
  };
  var initTagalysRecommendations = (widgetElem) => {
    onTagalysReady(() => tagalysRecommendations(widgetElem));
  };

  // src/scripts/sections/product-recommendations.js
  var sectionType = "product-recommendations-recently";
  var selectors2 = {
    tagalysWidget: '[data-tagalys-widget="recommendations"]',
    prevButton: "[data-prev-btn]",
    nextButton: "[data-next-btn]",
    recommendedWrapper: "[data-recommended-wrapper]",
    recommendedSliderContainer: "[data-recommended-slider]",
    productCard: "[data-product-card]",
    sliderDesktop: ".slider--desktop"
  };
  var productRecommendations = (section) => {
    const container = section.querySelector(`[data-section-type="${sectionType}"]`);
    const tagalysRecommendations2 = container.querySelector(selectors2.tagalysWidget);
    if (!tagalysRecommendations2) return;
    initTagalysRecommendations(tagalysRecommendations2);
  };

  // src/scripts/components/tagalys-search-suggestions.js
  var selectors3 = {
    searchInput: "[data-TWP-search-input]",
    featuredProductsWidget: '[data-tagalys-widget="featured-products-suggestions"]'
  };
  var renderProductsList = (html, args) => {
    const props = args.props;
    const products = props.helpers.getProducts();
    return html`<div>
    <ul class="TWP-predictive-search__results-list--products predictive-search__results-list list-unstyled">
      ${products.map((product) => {
      return html`
          <li class="predictive-search__list-item">
            <${args.templates.product} key=${product.id} product=${product} />
          </li>
        `;
    })}
    </ul>
  </div>`;
  };
  var renderProduct = (html, args) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const props = args.props;
    const product = props.product;
    const helpers = props.helpers;
    const productOptions = helpers.getTemplateOptions("product");
    const productUrl = productOptions.productPageUrl(product);
    const badgeTags = product.tags ? (_a = product.tags) == null ? void 0 : _a.filter((tag) => tag.includes("label:")) : [];
    return html`
    <a
      href=${productUrl}
      class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text product-card-wrapper-TWP"
    >
      ${product.featured_image ? html`<img
            class="predictive-search__image"
            src="${product.featured_image.src}&width=340"
            srcset="
              ${product.featured_image.src}&width=160   160w,
              ${product.featured_image.src}&width=360   360w,
              ${product.featured_image.src}&width=533   533w,
              ${product.featured_image.src}&width=720   720w,
              ${product.featured_image.src}&width=940   940w,
              ${product.featured_image.src}&width=1066 1066w,
              ${product.featured_image.src}&width=2132 2132w
            "
            sizes="(min-width: 768px) 25vw, 30vw"
            width="${product.featured_image.width}"
            height="${product.featured_image.height}"
            alt="${(_b = product.featured_image.alt) != null ? _b : product.title}"
          />` : null}

      <div class="predictive-search__item-content">
        <span class="visually-hidden">${(_e = (_d = (_c = window.theme) == null ? void 0 : _c.strings) == null ? void 0 : _d.accessibility) == null ? void 0 : _e.vendor}</span>
        <div class="predictive-search__item-vendor caption-with-letter-spacing">${product.vendor}</div>

        <p class="predictive-search__item-heading paragraph--small">${product.title}</p>

        ${helpers.isProductOnSale(product.compare_at_price, product.price) ? html`
              <p class="price price--on-sale">
                <div class="price__sale">
                  <span class="visually-hidden">${(_g = (_f = window.theme) == null ? void 0 : _f.strings) == null ? void 0 : _g.regularPriceLabel}</span>
                  <s class="price-item price-item--regular">
                    ${helpers.formatCurrency(product.compare_at_price)}
                  </s>
                  <span class="visually-hidden">${(_i = (_h = window.theme) == null ? void 0 : _h.strings) == null ? void 0 : _i.salePriceLabel}</span>
                  <span class="price-item price-item--sale price-item--last">
                    ${helpers.formatCurrency(product.price)}
                  </span>
                </div>
              </p>
            ` : html`
              <p class="price">
                <div class="price__regular">
                  <span class="price-item price-item--regular">${helpers.formatCurrency(product.price)}</span>
                </div>
              </p>
            `}
      </div>

      ${badgeTags.length > 0 ? html`
            <div class="card__badge">
              ${badgeTags.map((tag) => {
      const badgeText = tag.replace("label:", "");
      return html`<span class="badge">${badgeText}</span>`;
    })}
            </div>
          ` : ""}
    </a>
  `;
  };
  var initTagalysSearchSuggestions = () => {
    onTagalysReady(() => {
      var _a, _b, _c;
      const searchInput = document.querySelector(selectors3.searchInput);
      if (!searchInput) return;
      const rootUrl = window.theme.locale && !window.theme.locale.primary ? window.theme.locale.rootUrl : "";
      (_c = (_b = (_a = window.Tagalys) == null ? void 0 : _a.UIWidgets) == null ? void 0 : _b.SearchSuggestions) == null ? void 0 : _c.init(selectors3.searchInput, {
        searchResultsURL: `${rootUrl}${window.theme.routes.search}`,
        templates: {
          widget: {
            options: {
              includeTagalysCSS: false,
              request: {
                products: {
                  limit: 3
                },
                collections: {
                  limit: 5
                },
                pages: {
                  limit: 5
                }
              },
              inheritAlignmentElementWidth: false,
              position(inputDOMNode, widgetDOMNode) {
                const searchForm = inputDOMNode.parentElement;
                const widgetParent = widgetDOMNode.parentElement;
                searchForm.after(widgetParent);
                return false;
              }
            }
          },
          hint: {
            render(html) {
              return html``;
            }
          },
          clickSuggestions: {
            // Displayed before the user enters the minimum required characters
            render(html, args) {
              var _a2, _b2, _c2, _d, _e, _f;
              const props = args.props;
              const helpers = props.helpers;
              const recentAndPopularSearches = helpers.getRecentAndPopularSearches();
              const recentSearches = recentAndPopularSearches.recentSearches;
              const popularSearches = recentAndPopularSearches.popularSearches;
              return html`
              <div class="predictive-search__results-groups-wrapper">
                <div class="predictive-search__result-group">
                  ${recentSearches.length > 0 ? html`
                        <div>
                          <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                            ${(_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.search) == null ? void 0 : _c2.recentSearches}
                          </h2>
                          <ul class="predictive-search__results-list list-unstyled">
                            ${recentSearches.map(
                (recentSearch) => html`
                                <li>
                                  <a
                                    href=${helpers.getLink(recentSearch.queryString)}
                                    class="predictive-search__item link link--text"
                                  >
                                    <span
                                      class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                                    >
                                      ${recentSearch.displayString}
                                    </span>
                                  </a>
                                </li>
                              `
              )}
                          </ul>
                        </div>
                      ` : null}
                  ${popularSearches.length > 0 ? html`
                        <div>
                          <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                            ${(_f = (_e = (_d = window.theme) == null ? void 0 : _d.strings) == null ? void 0 : _e.search) == null ? void 0 : _f.popularSearches}
                          </h2>
                          <ul class="predictive-search__results-list list-unstyled">
                            ${popularSearches.map(
                (popularSearch) => html`
                                <li>
                                  <a
                                    href=${helpers.getLink(popularSearch.queryString)}
                                    class="predictive-search__item link link--text"
                                  >
                                    <span
                                      class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                                    >
                                      ${popularSearch.displayString}
                                    </span>
                                  </a>
                                </li>
                              `
              )}
                          </ul>
                        </div>
                      ` : null}
                </div>
                <div class="predictive-search__result-group">
                  <${args.templates.featuredProductsSuggestions} />
                </div>
              </div>
            `;
            }
          },
          featuredProductsSuggestions: {
            render(html) {
              return html`<div
              className="featured-products-suggestions featured_products-wrapper"
              data-tagalys-widget="featured-products-suggestions"
            ></div>`;
            },
            callbacks: {
              afterInitialRender: () => {
                var _a2, _b2;
                const widgetId = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.tagalys) == null ? void 0 : _b2.featuredProductsWidget.id;
                if (!widgetId) return;
                window.Tagalys.UIWidgets.SmartWidget.init(selectors3.featuredProductsWidget, {
                  widgetId,
                  templates: {
                    widget: {
                      options: {
                        limit: 3,
                        displayFormat: "grid",
                        includeTagalysCSS: false
                      },
                      render: (html, args) => {
                        const props = args.props;
                        const helpers = props.helpers;
                        const products = helpers.getProducts();
                        if (props.loading === false) {
                          if (products.length === 0) {
                            return null;
                          }
                          return html` <${args.templates.products} /> `;
                        }
                      }
                    },
                    products: {
                      render: (html, args) => {
                        return renderProductsList(html, args);
                      }
                    },
                    product: {
                      render(html, args) {
                        return renderProduct(html, args);
                      }
                    }
                  }
                });
              }
            }
          },
          typeSuggestions: {
            // Displays suggestions (products, collections, pages) after user enters the minimum required characters
            render(html, args) {
              var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l;
              const props = args.props;
              const helpers = props.helpers;
              const response = helpers.getAPIResponse();
              const responseTotal = (_b2 = (_a2 = response == null ? void 0 : response.metadata) == null ? void 0 : _a2.products) == null ? void 0 : _b2.total;
              const searchTerm = props.helpers.getEnteredSearchQuery();
              const searchPageUrl = `${rootUrl}${window.theme.routes.search}?q=${searchTerm}`;
              return html`
              <div class="predictive-search__results-groups-wrapper">
                <!--------- TEXT SUGGESTIONS (collections and pages) --------->
                <div class="predictive-search__result-group">
                  ${helpers.hasTextSearchSuggestions() ? html` <${args.templates.textSuggestions} /> ` : null}
                </div>

                <!--------- PRODUCTS SUGGESTIONS --------->
                <div class="predictive-search__result-group">
                  <${args.templates.products} />
                </div>
              </div>

              <div class="predictive-search__search-for-button">
                ${responseTotal ? html`
                      <p class="predictive-search__results-count caption-with-letter-spacing hide--max-md">
                        ${responseTotal === 1 ? (_f = (_e = (_d = (_c2 = window.theme) == null ? void 0 : _c2.strings) == null ? void 0 : _d.search) == null ? void 0 : _e.resultsWithCount.one) == null ? void 0 : _f.replace("{{ count }}", responseTotal) : (_i = (_h = (_g = window.theme) == null ? void 0 : _g.strings) == null ? void 0 : _h.search) == null ? void 0 : _i.resultsWithCount.other.replace("{{ count }}", responseTotal)}
                      </p>
                    ` : null}

                <a
                  href=${encodeURI(searchPageUrl)}
                  class="predictive-search__item predictive-search__item--term button button--primary animate-arrow"
                >
                  <span data-predictive-search-search-for-text>${(_l = (_k = (_j = window.theme) == null ? void 0 : _j.strings) == null ? void 0 : _k.search) == null ? void 0 : _l.view_all}</span>
                </a>
              </div>
            `;
            }
          },
          textSuggestions: {
            render(html, args) {
              const props = args.props;
              const helpers = props.helpers;
              const textSuggestions = helpers.getTextSuggestions();
              return html`
              ${textSuggestions.map(
                (suggestion) => {
                  var _a2;
                  return html`
                  <div>
                    <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                      ${suggestion.section_title}
                    </h2>
                    <ul class="predictive-search__results-list list-unstyled">
                      ${(_a2 = suggestion.items) == null ? void 0 : _a2.map(
                    (item) => html`
                          <li class="predictive-search__list-item">
                            <a href=${item.link} class="predictive-search__item link link--text" tabindex="-1">
                              <span
                                class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                              >
                                ${item.displayString}
                              </span>
                            </a>
                          </li>
                        `
                  )}
                    </ul>
                  </div>
                `;
                }
              )}
            `;
            }
          },
          products: {
            render(html, args) {
              return renderProductsList(html, args);
            }
          },
          product: {
            render(html, args) {
              return renderProduct(html, args);
            }
          }
        },
        callbacks: {
          afterInitialRender: () => {
            const headerSection = document.querySelector(".section-header");
            const resultsContainer = document.querySelector(".tagalys-search-suggestions");
            if (!headerSection || !resultsContainer) return;
            const resultsMaxHeight = window.innerHeight - headerSection.getBoundingClientRect().bottom;
            resultsContainer.style.maxHeight = `${resultsMaxHeight}px`;
          }
        }
      });
    });
  };

  // src/scripts/components/tagalys-search-results.js
  var selectors4 = {
    widget: '[data-tagalys-widget="search-results"]',
    drawer: "[data-filters-drawer]"
  };
  var tagalysSearchResults = (container) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V, _W, _X, _Y, _Z, __, _$, _aa, _ba, _ca, _da, _ea, _fa, _ga, _ha, _ia, _ja, _ka, _la, _ma, _na, _oa, _pa, _qa, _ra, _sa, _ta, _ua, _va, _wa, _xa, _ya, _za, _Aa, _Ba, _Ca, _Da, _Ea;
    const widgetElem = container.querySelector(selectors4.widget);
    if (!widgetElem) return;
    const itemsPerPage = (_a = widgetElem.dataset.limit) != null ? _a : 24;
    const noResultsWidgetId = (_b = widgetElem.dataset) == null ? void 0 : _b.noResultsWidget;
    const noResultsWidgetLimit = (_c = widgetElem.dataset.noResultsWidgetLimit) != null ? _c : 4;
    (_Ea = (_e = (_d = window.Tagalys) == null ? void 0 : _d.UIWidgets) == null ? void 0 : _e.SearchResults) == null ? void 0 : _Ea.init(selectors4.widget, {
      templates: {
        widget: {
          options: {
            limit: itemsPerPage,
            includeTagalysCSS: false
          },
          labels: {
            searchResults: {
              heading: {
                standard: (_g = (_f = window.theme) == null ? void 0 : _f.strings.search) == null ? void 0 : _g.titleWithCount,
                corrected: (_i = (_h = window.theme) == null ? void 0 : _h.strings.search) == null ? void 0 : _i.titleCorrected,
                partialMatches: (_k = (_j = window.theme) == null ? void 0 : _j.strings.search) == null ? void 0 : _k.titlePartialMatches,
                noResults: (_m = (_l = window.theme) == null ? void 0 : _l.strings.search) == null ? void 0 : _m.noResults
              }
            },
            filters: {
              heading: (_r = (_q = (_p = (_o = (_n = window.theme) == null ? void 0 : _n.strings) == null ? void 0 : _o.search) == null ? void 0 : _p.filters) == null ? void 0 : _q.heading) != null ? _r : "Filter",
              selected: (_w = (_v = (_u = (_t = (_s = window.theme) == null ? void 0 : _s.strings) == null ? void 0 : _t.search) == null ? void 0 : _u.filters) == null ? void 0 : _v.selected) != null ? _w : "{{ count }} selected",
              maxPrice: (_B = (_A = (_z = (_y = (_x = window.theme) == null ? void 0 : _x.strings) == null ? void 0 : _y.search) == null ? void 0 : _z.filters) == null ? void 0 : _A.maxPrice) != null ? _B : "The highest price is {{ price }}",
              from: (_G = (_F = (_E = (_D = (_C = window.theme) == null ? void 0 : _C.strings) == null ? void 0 : _D.search) == null ? void 0 : _E.filters) == null ? void 0 : _F.from) != null ? _G : "From",
              to: (_L = (_K = (_J = (_I = (_H = window.theme) == null ? void 0 : _H.strings) == null ? void 0 : _I.search) == null ? void 0 : _J.filters) == null ? void 0 : _K.to) != null ? _L : "To",
              reset: (_Q = (_P = (_O = (_N = (_M = window.theme) == null ? void 0 : _M.strings) == null ? void 0 : _N.search) == null ? void 0 : _O.filters) == null ? void 0 : _P.reset) != null ? _Q : "Reset",
              clear: (_V = (_U = (_T = (_S = (_R = window.theme) == null ? void 0 : _R.strings) == null ? void 0 : _S.search) == null ? void 0 : _T.filters) == null ? void 0 : _U.clear) != null ? _V : "Clear",
              clearFilter: (__ = (_Z = (_Y = (_X = (_W = window.theme) == null ? void 0 : _W.strings) == null ? void 0 : _X.search) == null ? void 0 : _Y.filters) == null ? void 0 : _Z.clearFilter) != null ? __ : "Remove",
              clearAll: (_da = (_ca = (_ba = (_aa = (_$ = window.theme) == null ? void 0 : _$.strings) == null ? void 0 : _aa.search) == null ? void 0 : _ba.filters) == null ? void 0 : _ca.clearAll) != null ? _da : "Remove all",
              apply: (_ia = (_ha = (_ga = (_fa = (_ea = window.theme) == null ? void 0 : _ea.strings) == null ? void 0 : _fa.search) == null ? void 0 : _ga.filters) == null ? void 0 : _ha.apply) != null ? _ia : "Apply",
              label: (_na = (_ma = (_la = (_ka = (_ja = window.theme) == null ? void 0 : _ja.strings) == null ? void 0 : _ka.search) == null ? void 0 : _la.filters) == null ? void 0 : _ma.label) != null ? _na : "Filter",
              buttonLabel: (_sa = (_ra = (_qa = (_pa = (_oa = window.theme) == null ? void 0 : _oa.strings) == null ? void 0 : _pa.search) == null ? void 0 : _qa.filters) == null ? void 0 : _ra.buttonLabel) != null ? _sa : "Filter"
            },
            sortOptions: {
              label: (_va = (_ua = (_ta = window.theme) == null ? void 0 : _ta.strings) == null ? void 0 : _ua.search) == null ? void 0 : _va.sortBy
            },
            resultsWithCount: {
              one: (_za = (_ya = (_xa = (_wa = window.theme) == null ? void 0 : _wa.strings) == null ? void 0 : _xa.search) == null ? void 0 : _ya.resultsWithCount) == null ? void 0 : _za.one,
              other: (_Da = (_Ca = (_Ba = (_Aa = window.theme) == null ? void 0 : _Aa.strings) == null ? void 0 : _Ba.search) == null ? void 0 : _Ca.resultsWithCount) == null ? void 0 : _Da.other
            }
          },
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            if (helpers.isInitialLoading()) {
              return html` <${args.templates.loader} /> `;
            }
            if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
              return html` <${args.templates.noResults} /> `;
            }
            return html`
            <${args.templates.header} />
            <${args.templates.productListHeader} />
            <div class="product-grid-container" id="ProductGridContainer">
              <div class="template-search__results collection" id="product-grid">
                <${args.templates.products} />
                <${args.templates.productListFooter} />
              </div>
            </div>
          `;
          }
        },
        loader: {
          render(html) {
            return html`
            <div class="loading__spinner">
              <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path" />
              </svg>
            </div>
          `;
          }
        },
        header: {
          render(html, args) {
            return html`
            <div class="template-search__header page-width scroll-trigger animate--fade-in">
              <${args.templates.heading} />
            </div>
          `;
          }
        },
        heading: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const getHeadingBasedOnAPIResponse = () => {
              var _a2, _b2, _c2, _d2;
              let headingText;
              if (!helpers.getQuery()) {
                headingText = (_d2 = (_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.search) == null ? void 0 : _c2.search) != null ? _d2 : "Search";
              } else if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
                headingText = labels.searchResults.heading.noResults.replace("{{ terms }}", helpers.getQuery());
              } else if (helpers.isPartialResults()) {
                headingText = labels.searchResults.heading.partialMatches.replace("{{searchTerm}}", helpers.getQuery());
              } else if (helpers.isSpellingCorrectedQuery()) {
                headingText = labels.searchResults.heading.corrected.replace("{{originalSearchTerm}}", helpers.getOriginalQuery()).replace("{{resultsCount}}", helpers.getTotalProductsCount()).replace("{{correctedSearchTerm}}", helpers.getQuery());
              } else {
                headingText = labels.searchResults.heading.standard.replace("{{resultsCount}}", helpers.getTotalProductsCount()).replace("{{searchTerm}}", helpers.getQuery());
              }
              return decodeHtmlEntities(headingText);
            };
            return html`<h1 class="h5 center">${getHeadingBasedOnAPIResponse()}</h1>`;
          }
        },
        productListHeader: {
          render(html, args) {
            const labels = args.labels;
            return html`
            <div id="main-search-filters" class="facets-wrapper facets-wrapper-TWP page-width">
              <div class="TWP-facets-container--horizontal facets-container scroll-trigger animate--fade-in">
                <!---------- DESKTOP FILTERS ---------->
                <div class="facets small-hide">
                  <div class="facets__form">
                    <${args.templates.filters} type="desktop" />
                    <${args.templates.sortOptions} type="desktop" />
                    <div class="product-count light" role="status">
                      <h2 class="product-count__text text-body">
                        <${args.templates.resultsCountLabel} />
                      </h2>
                    </div>
                  </div>
                </div>

                <!---------- MOBILE FILTERS ---------->
                <menu-drawer
                  class="mobile-facets__wrapper medium-hide large-up-hide"
                  data-breakpoint="mobile"
                  data-filters-drawer
                >
                  <details class="mobile-facets__disclosure disclosure-has-popup">
                    <summary class="mobile-facets__open-wrapper focus-offset">
                      <span class="mobile-facets__open">
                        <span class="mobile-facets__open-label button-label medium-hide large-up-hide">
                          ${labels.filters.label}
                        </span>
                        <span class="mobile-facets__open-label button-label small-hide"
                          >${labels.filters.buttonLabel}</span
                        >
                      </span>
                      <span tabindex="0" class="mobile-facets__close">
                        <span class="svg-wrapper"
                          ><svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            class="icon icon-close"
                            viewBox="0 0 18 17"
                          >
                            <path
                              fill="currentColor"
                              d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                            />
                          </svg>
                        </span>
                      </span>
                    </summary>
                    <div class="facet-filters-form">
                      <div class="mobile-facets">
                        <div class="mobile-facets__inner gradient">
                          <div class="mobile-facets__header">
                            <div class="mobile-facets__header-inner">
                              <h2 class="mobile-facets__heading medium-hide large-up-hide">${labels.filters.label}</h2>
                              <h2 class="mobile-facets__heading small-hide">${labels.filters.buttonLabel}</h2>
                              <p class="mobile-facets__count"><${args.templates.resultsCountLabel} /></p>
                            </div>
                          </div>
                          <${args.templates.filters} type="mobile" />
                        </div>
                      </div>
                    </div>
                  </details>
                </menu-drawer>
              </div>
              <div class="active-facets active-facets-mobile medium-hide large-up-hide">
                <${args.templates.appliedFilters} />
              </div>
            </div>
          `;
          },
          callbacks: {
            afterInitialRender: () => {
              const menuDrawer = widgetElem.querySelector(selectors4.drawer);
              menuDrawer == null ? void 0 : menuDrawer.setAttribute("data-initialized", "");
            }
          }
        },
        filters: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const filters = helpers.getFilters();
            if (props.type === "mobile") {
              return html`
              <div id="FacetsWrapperMobile" class="mobile-facets__main has-submenu gradient">
                ${filters.map(
                (filter, index) => html`<${args.templates.filterMobile} filter=${filter} index=${index + 1} />`
              )}
                <${args.templates.sortOptions} type="mobile" />

                <div class="mobile-facets__footer">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${() => helpers.clearAllFilters()}
                    >
                      ${labels.filters.clearAll}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${(event) => {
                var _a2, _b2;
                (_b2 = (_a2 = event.target.closest(".mobile-facets__wrapper")) == null ? void 0 : _a2.querySelector("summary")) == null ? void 0 : _b2.click();
              }}
                  >
                    ${labels.filters.apply}
                  </button>
                </div>
              </div>
            `;
            }
            return html`
            <div id="FacetsWrapperDesktop" class="facets__wrapper">
              <h2 class="facets__heading caption-large text-body" id="verticalTitle" tabindex="-1">
                ${labels.filters.heading}
              </h2>

              ${filters.map((filter, index) => html`<${args.templates.filter} filter=${filter} index=${index + 1} />`)}
            </div>
            <div class="active-facets active-facets-desktop">
              <${args.templates.appliedFilters} />
            </div>
          `;
          }
        },
        filterMobile: {
          render(html, args) {
            var _a2;
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const filter = props.filter;
            const index = props.index;
            let selectedFiltersLabel = "";
            if (filter.type === "range") {
              const maxPrice = helpers.labelFormatter(filter.display_format, filter.max, filter.currency);
              selectedFiltersLabel = labels.filters.maxPrice.replace("{{ price }}", maxPrice);
            }
            return html`
            <details
              id="Details-Mobile-${filter.id}-search"
              class="mobile-facets__details"
              data-index="mobile-${index}"
            >
              <summary class="mobile-facets__summary focus-inset">
                <div>
                  <span>${filter.name}</span>
                  <span class="mobile-facets__arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </span>
                </div>
              </summary>

              <div id="FacetMobile-${index}-search" class="mobile-facets__submenu gradient">
                <button
                  class="mobile-facets__close-button link link--text focus-inset"
                  aria-expanded="true"
                  type="button"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10">
                    <path
                      fill="currentColor"
                      fill-rule="evenodd"
                      d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546"
                      clip-rule="evenodd"
                    />
                  </svg>

                  <span>${filter.name}</span>
                </button>

                ${filter.type === "range" ? html` <p class="mobile-facets__info">${selectedFiltersLabel}</p>
                      <${args.templates.rangeSliderFilterItem} filter=${filter} />` : html`
                      <ul
                        class="facets-layout facets-layout-list facets-layout-list--text mobile-facets__list list-unstyled"
                        role="list"
                      >
                        ${(_a2 = filter.items) == null ? void 0 : _a2.map(
              (filterItem, index2) => html`<${args.templates.filterItemMobile}
                              filterItem=${filterItem}
                              index=${index2 + 1}
                              filterId=${filter.id}
                            />`
            )}
                      </ul>
                    `}

                <div class="mobile-facets__footer gradient">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${() => helpers.clearFilter(filter.id)}
                    >
                      ${labels.filters.clear}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${(event) => {
              var _a3, _b2;
              (_b2 = (_a3 = event.target.closest(".mobile-facets__wrapper")) == null ? void 0 : _a3.querySelector("summary")) == null ? void 0 : _b2.click();
            }}
                  >
                    ${labels.filters.apply}
                  </button>
                </div>
              </div>
            </details>
          `;
          }
        },
        filter: {
          render(html, args) {
            var _a2;
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const filter = props.filter;
            const index = props.index;
            const selectedFiltersCount = (_a2 = filter.items) == null ? void 0 : _a2.filter((item) => item.selected).length;
            let selectedFiltersLabel = labels.filters.selected.replace("{{ count }}", selectedFiltersCount);
            if (filter.type === "range") {
              const maxPrice = helpers.labelFormatter(filter.display_format, filter.max, filter.currency);
              selectedFiltersLabel = labels.filters.maxPrice.replace("{{ price }}", maxPrice);
            }
            return html`
            <details
              id="Details-${filter.id}-search"
              class="disclosure-has-popup facets__disclosure"
              data-index="${index}"
            >
              <summary class="facets__summary caption-large focus-offset">
                <div>
                  <span class="facets__summary-label">${filter.name}</span>
                  <svg class="icon icon-caret" viewBox="0 0 10 6">
                    <path
                      fill="currentColor"
                      fill-rule="evenodd"
                      d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
              </summary>

              <div id="Facet-${index}-search" class="parent-display facets__display">
                <div class="facets__header">
                  <div>
                    <span class="facets__selected">${selectedFiltersLabel}</span>
                  </div>

                  <button
                    type="button"
                    class="facets__reset link underlined-link"
                    onClick=${() => helpers.clearFilter(filter.id)}
                  >
                    ${labels.filters.reset}
                  </button>
                </div>

                <${args.templates.filterItems} filter=${filter} />
              </div>
            </details>
          `;
          }
        },
        filterItems: {
          render(html, args) {
            var _a2;
            const props = args.props;
            if (props.filter.type === "checkbox") {
              return html` <fieldset class="facets-wrap parent-wrap">
              <legend class="visually-hidden">${props.filter.name}</legend>
              <ul
                class="facets-layout facets-layout-list facets-layout-list--text facets__list list-unstyled"
                role="list"
              >
                ${(_a2 = props.filter.items) == null ? void 0 : _a2.map(
                (filterItem, index) => html`<${args.templates.filterItem}
                      filterItem=${filterItem}
                      index=${index + 1}
                      filterId=${props.filter.id}
                    />`
              )}
              </ul>
            </fieldset>`;
            }
            if (props.filter.type === "range") {
              return html`<${args.templates.rangeSliderFilterItem} filter=${props.filter} />`;
            }
          }
        },
        filterItem: {
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const filterItem = props.filterItem;
            const inputId = `Filter-${props.filterId}-${props.index}`;
            const onFilterClick = (event) => {
              event.stopPropagation();
              if (props.filterItem.selected) {
                helpers.clearFilter(props.filterId, props.filterItem.id);
              } else {
                helpers.applyFilter(props.filterId, props.filterItem.id);
              }
            };
            return html`<li class="list-menu__item facets__item">
            <label for=${inputId} class="facets__label facet-checkbox" onclick=${onFilterClick}>
              <input
                type="checkbox"
                name=${props.filterId}
                value=${filterItem.name}
                id=${inputId}
                checked=${filterItem.selected}
              />

              <svg width="16px" height="16px" viewBox="0 0 16 16">
                <rect width="16" height="16" fill="none" stroke="currentColor" />
              </svg>

              <div class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9">
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label">${filterItem.name}</span> (${filterItem.count})
              </span>
            </label>
          </li>`;
          }
        },
        filterItemMobile: {
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const filterItem = props.filterItem;
            const inputId = `Filter-${props.filterId}-${props.index}`;
            const onFilterClick = (event) => {
              event.stopPropagation();
              if (props.filterItem.selected) {
                helpers.clearFilter(props.filterId, props.filterItem.id);
              } else {
                helpers.applyFilter(props.filterId, props.filterItem.id);
              }
            };
            return html`<li class="mobile-facets__item list-menu__item">
            <label for=${inputId} class="facets__label mobile-facets__label" onclick=${onFilterClick}>
              <input
                class="mobile-facets__checkbox"
                type="checkbox"
                name=${props.filterId}
                value=${filterItem.name}
                id=${inputId}
                checked=${filterItem.selected}
              />

              <span class="mobile-facets__highlight"></span>

              <svg width="16px" height="16px" viewBox="0 0 16 16">
                <rect width="16" height="16" fill="none" stroke="currentColor" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-checkmark" viewBox="0 0 12 9">
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
                  clip-rule="evenodd"
                />
              </svg>

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label">${filterItem.name}</span> (${filterItem.count})
              </span>
            </label>
          </li>`;
          }
        },
        rangeSliderFilterItem: {
          render(html, args) {
            var _a2, _b2, _c2, _d2;
            const props = args.props;
            const labels = args.labels;
            const inputId = `Filter-${props.filter.name}-`;
            return html`
            <div class="facets__price">
              <div class="hide" ref=${props.sliderRef} />
              <span class="field-currency">${(_b2 = (_a2 = window.theme) == null ? void 0 : _a2.localization) == null ? void 0 : _b2.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${inputId}-GTE`}
                  class="field__input"
                  type="number"
                  value=${props.sliderInputValues[0]}
                  onblur=${props.onInputBlur}
                  onchange=${props.onMinChange}
                />
                <label class="field__label" for=${`${inputId}-GTE`}>${labels.filters.from}</label>
              </div>
              <span class="field-currency">${(_d2 = (_c2 = window.theme) == null ? void 0 : _c2.localization) == null ? void 0 : _d2.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${inputId}-LTE`}
                  class="field__input"
                  type="number"
                  value=${props.sliderInputValues[1]}
                  onblur=${props.onInputBlur}
                  onchange=${props.onMaxChange}
                />
                <label class="field__label" for=${`${inputId}-LTE`}>${labels.filters.to}</label>
              </div>
            </div>
          `;
          }
        },
        appliedFilters: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const appliedFilters = helpers.getAppliedFilters(true);
            if (!appliedFilters.length) return "";
            return html`
            ${appliedFilters.map((filter) => {
              var _a2;
              if (filter.type === "range") {
                return html`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light"
                    onClick=${() => helpers.clearFilter(filter.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${helpers.labelFormatter(filter.display_format, filter.selected_min, filter.currency)} -
                      ${helpers.labelFormatter(filter.display_format, filter.selected_max, filter.currency)}
                      <span class="svg-wrapper">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          class="icon icon-close-small"
                          viewBox="0 0 12 13"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"
                          />
                        </svg>
                      </span>
                      <span class="visually-hidden">${labels.filters.clearFilter}</span>
                    </span>
                  </button>
                `;
              }
              return (_a2 = filter.items) == null ? void 0 : _a2.map((item) => {
                return html`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light"
                    onClick=${() => helpers.clearFilter(filter.id, item.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${filter.name}: ${item.name}
                      <span class="svg-wrapper">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          class="icon icon-close-small"
                          viewBox="0 0 12 13"
                        >
                          <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"
                          />
                        </svg>
                      </span>
                      <span class="visually-hidden">${labels.filters.clearFilter}</span>
                    </span>
                  </button>
                `;
              });
            })}

            <div class="active-facets__button-wrapper">
              <button
                type="button"
                class="active-facets__button-remove underlined-link"
                onClick=${() => helpers.clearAllFilters()}
              >
                <span>${labels.filters.clearAll}</span>
              </button>
            </div>
          `;
          }
        },
        sortOptions: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const sortOptions = helpers.getSortOptions();
            const appliedSortOption = helpers.getAppliedSortOption();
            const applySortOption = (event) => {
              helpers.applySortOption(event.target.value);
            };
            if (props.type === "mobile") {
              return html`
              <div id="Details-Mobile-SortBy-search" class="mobile-facets__details js-filter">
                <div class="mobile-facets__summary">
                  <div class="mobile-facets__sort">
                    <label for="SortBy-mobile">${labels.sortOptions.label}</label>
                    <div class="select">
                      <select
                        name="sort_by"
                        class="select__select"
                        id="SortBy-mobile"
                        value=${appliedSortOption.id}
                        onchange=${applySortOption}
                      >
                        ${sortOptions.map(
                (sortOption) => html` <option value=${sortOption.id}>${sortOption.label}</option>`
              )}
                      </select>
                      <span class="svg-wrapper">
                        <svg class="icon icon-caret" viewBox="0 0 10 6">
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            `;
            }
            return html`
            <div class="facet-filters sorting caption">
              <div class="facet-filters__field">
                <h2 class="facet-filters__label caption-large text-body">
                  <label for="SortBy">${labels.sortOptions.label}</label>
                </h2>
                <div class="select">
                  <select
                    class="facet-filters__sort select__select caption-large"
                    id="SortBy"
                    name="sort_by"
                    value=${appliedSortOption.id}
                    onchange=${applySortOption}
                  >
                    ${sortOptions.map(
              (sortOption) => html` <option value=${sortOption.id}>${sortOption.label}</option>`
            )}
                  </select>

                  <span class="svg-wrapper">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 6L8 10L12 6" stroke="#221F20" />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          `;
          }
        },
        resultsCountLabel: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;
            const totalProductsCount = helpers.getTotalProductsCount();
            const resultsLabelTemplate = totalProductsCount === 1 ? labels.resultsWithCount.one : labels.resultsWithCount.other;
            const resultsLabel = resultsLabelTemplate == null ? void 0 : resultsLabelTemplate.replace("{{ count }}", totalProductsCount);
            return html`${resultsLabel}`;
          }
        },
        products: {
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const products = helpers.getProducts();
            return html`
            <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" role="list">
              ${products.map((product) => html`<${args.templates.product} key=${product.id} product=${product} />`)}
            </ul>
          `;
          }
        },
        product: {
          render(html, args) {
            const props = args.props;
            const product = props.product;
            const helpers = props.helpers;
            return html`<li
            class="grid__item scroll-trigger animate--slide-in"
            dangerouslySetInnerHTML=${{ __html: product_card_render_default(product, helpers) }}
          />`;
          }
        },
        productListFooter: {
          render(html, args) {
            return html` <${args.templates.pagination} /> `;
          }
        },
        pagination: {
          render(html, args) {
            return html`
            <div class="pagination-wrapper">
              <nav class="pagination" role="navigation" aria-label="Pagination">
                <${args.templates.paginationLinks} />
              </nav>
            </div>
          `;
          }
        },
        paginationLinks: {
          options: {
            showNumberedPageLinks: true,
            numberedPageLinksWindowSize: 3,
            showPreviousPageLink: true,
            showFirstPageLink: false,
            showNextPageLink: true,
            scrollTop: true
          },
          render(html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const pagesToDisplay = helpers.getPagesToDisplay(props.numberedPageLinksWindowSize);
            const hasPreviousPage = helpers.hasPreviousPage();
            const hasNextPage = helpers.hasNextPage();
            return html`
            <ul class="pagination__list list-unstyled" role="list">
              ${props.showPreviousPageLink && hasPreviousPage ? html` <li>
                    <button
                      type="button"
                      class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
                      aria-label="Previous page"
                      onclick=${helpers.goToPreviousPage}
                    >
                      <span class="svg-wrapper">
                        <svg class="icon icon-caret" viewBox="0 0 10 6">
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </span>
                    </button>
                  </li>` : null}
              ${props.showNumberedPageLinks ? pagesToDisplay.map((pageDetail) => {
              const classes2 = ["pagination__item link"];
              const isEllipsis = pageDetail.jumpAfter;
              if (pageDetail.current) classes2.push("pagination__item--current");
              const className = classes2.join(" ");
              if (isEllipsis) {
                return html`
                        <li>
                          <span class="pagination__item tt">...</span>
                        </li>
                      `;
              }
              return html`
                      <li>
                        <button
                          type="button"
                          class=${`${className}`}
                          onclick=${() => {
                helpers.goToPage(pageDetail.page);
              }}
                        >
                          ${pageDetail.page}
                        </button>
                      </li>
                    `;
            }) : null}
              ${props.showNextPageLink && hasNextPage ? html`
                    <li>
                      <button
                        type="button"
                        class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                        aria-label="Next page"
                        onclick=${helpers.goToNextPage}
                      >
                        <span class="svg-wrapper">
                          <svg class="icon icon-caret" viewBox="0 0 10 6">
                            <path
                              fill="currentColor"
                              fill-rule="evenodd"
                              d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </span>
                      </button>
                    </li>
                  ` : null}
            </ul>
          `;
          }
        },
        noResults: {
          options: {
            widgets: [
              {
                widgetId: noResultsWidgetId,
                options: {
                  templates: tagalys_widget_templates_default(noResultsWidgetLimit, widgetElem),
                  callbacks: {
                    afterInitialRender: () => {
                      const sliderComponent = widgetElem.querySelector("slider-component");
                      sliderComponent == null ? void 0 : sliderComponent.reinitialiseSlider();
                    }
                  }
                }
              }
            ]
          },
          render(html, args) {
            return html`
            <${args.templates.header} />

            ${noResultsWidgetId ? html`
                  <div class="product-recommendations__wrapper">
                    <${args.templates.noResultsWidgets} />
                  </div>
                ` : ""}
          `;
          }
        }
      },
      callbacks: {
        onSuccessfulAPICall: (response) => {
          var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
          const totalResults = response.total;
          const metaTitleTemplate = totalResults > 0 ? `${(_d2 = (_c2 = (_b2 = (_a2 = window.theme) == null ? void 0 : _a2.strings) == null ? void 0 : _b2.search) == null ? void 0 : _c2.metaTitle) == null ? void 0 : _d2.results} - ${window.shopName}` : `${(_h2 = (_g2 = (_f2 = (_e2 = window.theme) == null ? void 0 : _e2.strings) == null ? void 0 : _f2.search) == null ? void 0 : _g2.metaTitle) == null ? void 0 : _h2.noResults} - ${window.shopName}`;
          const metaTitle = metaTitleTemplate.replace("{{ count }}", totalResults).replace("{{ term }}", response.query);
          document.title = decodeHtmlEntities(metaTitle);
          return response;
        }
      }
    });
  };
  var initTagalysSearchResults = (container) => {
    onTagalysReady(() => {
      tagalysSearchResults(container);
    });
  };

  // src/scripts/layout/theme.js
  var selectors5 = {
    shopifySections: ".shopify-section",
    tagalysSearchResults: '[data-tagalys-widget="search-results"]'
  };
  var classes = {
    productRecommendations: "product-recommendations-recently"
  };
  document.addEventListener("DOMContentLoaded", () => {
    initTagalys();
    onTagalysReady(() => {
      var _a;
      if (((_a = window.Tagalys) == null ? void 0 : _a.Analytics) && typeof window.Tagalys.Analytics.trackPlatformEvents === "function") {
        window.Tagalys.Analytics.trackPlatformEvents();
      }
    });
    initTagalysSearchSuggestions();
    const shopifySections = document.querySelectorAll(selectors5.shopifySections);
    shopifySections.forEach((section) => {
      if (section.classList.contains(classes.productRecommendations)) {
        productRecommendations(section);
        return;
      }
      if (section.querySelector(selectors5.tagalysSearchResults)) {
        initTagalysSearchResults(section);
      }
    });
    document.addEventListener("shopify:section:load", (event) => {
      const sectionId = event.detail.sectionId;
      if (sectionId.includes("product_recommendations")) {
        const section = document.getElementById(`shopify-section-${sectionId}`);
        if (!section) return;
        productRecommendations(section);
      }
    });
    const copyButtons = document.querySelectorAll("[data-copy-button]");
    copyButtons.forEach((button) => {
      button.addEventListener("click", () => __async(void 0, null, function* () {
        let text = button.dataset.copyButton;
        if (!text) return;
        try {
          yield navigator.clipboard.writeText(text);
          button.disabled = true;
          setTimeout(() => {
            button.disabled = false;
          }, 1500);
        } catch (err) {
          window.console.error("Failed to copy text: ", err);
        }
      }));
    });
  });
})();
